import { createContext } from 'react'
import { TAutomationsContext } from './types'

export const AutomationsContext = createContext<TAutomationsContext>({

})